import styled, { css } from 'styled-components';

import { colorTokens } from '../../../tokens/globals/tokens';
import { controllerTokens } from '../../../tokens/components/Controller/tokens';
import Affix from '../Affix/Affix';

import { borderColors } from '../Controller/styles';

const ClickableAffix = styled(Affix)<{ disabled?: boolean; invalid?: boolean }>`
  background-color: ${colorTokens.GlobalBrandWhite};
  cursor: pointer;
  padding: 12px;
  outline: none;
  transition: border 80ms ease-out, box-shadow 80ms ease-out;

  &:hover {
    border-color: ${controllerTokens.ContainerBorderColorBaseHover};
    box-shadow: -1px 0 0 0 ${controllerTokens.ContainerBorderColorBaseHover};
  }

  // Three shadows needed to achieve desired look & feel:
  // 1. Creates a left line between the input and the button
  // 2. Creates the focus ring around the button
  // 2. Adds 1px to the left focus to offset (1) and reach an even visual result

  &:focus-visible {
    border-color: ${controllerTokens.ContainerBorderColorBaseKeyboardFocus};
    box-shadow: -1px 0 0 0 ${controllerTokens.ContainerBorderColorBaseKeyboardFocus},
      0 0 0 ${controllerTokens.ContainerShadowWidthBaseKeyboardFocus}
        ${controllerTokens.ContainerShadowColorBaseKeyboardFocus},
      -1px 0 0 ${controllerTokens.ContainerShadowWidthBaseKeyboardFocus} ${controllerTokens.ContainerShadowColorBaseKeyboardFocus};
  }

  /* Adds invalid styles to affix to match its input counterpart */
  ${props =>
    props.invalid &&
    !props.disabled &&
    css`
      &,
      &:hover {
        border-color: ${controllerTokens.ContainerBorderColorInvalidDefault};
        box-shadow: -1px 0 0 0 ${controllerTokens.ContainerBorderColorInvalidDefault};
      }

      &:focus-visible {
        border-color: ${controllerTokens.ContainerBorderColorInvalidDefault};
        box-shadow: -1px 0 0 0 ${controllerTokens.ContainerBorderColorInvalidDefault},
          0 0 0 ${controllerTokens.ContainerShadowWidthInvalidKeyboardFocus}
            ${controllerTokens.ContainerShadowColorInvalidKeyboardFocus},
          -1px 0 0 ${controllerTokens.ContainerShadowWidthInvalidKeyboardFocus} ${controllerTokens.ContainerShadowColorInvalidKeyboardFocus};
      }
    `}

  ${props =>
    props.disabled &&
    css`
      border-color: ${borderColors.disabled};
      cursor: not-allowed;
      background-color: ${controllerTokens.ContainerBackgroundColorDisabledDefault};
      color: ${controllerTokens.ContainerFontColorDisabledDefault};
      opacity: 1;

      &:hover {
        border-color: ${borderColors.disabled};
        box-shadow: -1px 0 0 0 ${borderColors.disabled};
      }
    `}
`;

export default ClickableAffix;
